import React from 'react';
import cn from '../../lib/bem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ProgressBarComponent from '../progressBar/progressBar_component';

import './headerWizard_component.scss';


const HeaderWizardComponent = ({stepNro, stepMax, title}) => {
    
    const classes = cn("headerWizardComponent");

    return (
        <div className={classes()}>
           
            <div className={classes('showProgressTop')}>
                <ProgressBarComponent label="pbSup" progress={((stepNro + 1) * 100) / stepMax} />
            </div>

            <div className={classes('cardContent')}>
                <div className={classes('cardPasos')}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                    <div className={classes('cardPasosItem')}>
                        <div className={classes('cardPasosItemPag')}>{stepNro + 1}</div>
                        <div className={classes('cardPasosItemPagInf')}>
                            <p><b>PASO {stepNro + 1}</b></p>
                            <p>{title}</p>
                        </div>
                    </div>
                </div>

                { 
                    stepNro + 1 === stepMax ? null :
                    <div className={classes('cardPasos')}>
                        <div className={classes('cardPasosItemPagDisable')}>
                            <p>Paso {stepNro + 2}</p>
                        </div>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                }
            </div>
            
            <div className={classes('showProgressBottom')}>
                <ProgressBarComponent label="pbInf" progress={((stepNro + 1) * 100) / stepMax} />
            </div>
            <div className={classes('showProgressTop')}>
                <hr />
            </div>

        </div>
    )

}

export default HeaderWizardComponent;